import React, { useRef } from "react";
import styles from "./AttachmentList.module.css";
import { getIconForContentType } from "../utils/getIconForContentType";
import AttachmentHandler from "../components/AttachmentHandler";


// Normalize attachments similar to ExtendedCard
const normalizeAttachments = (entry) => {
    if (!entry || !entry.resource) return [];

    const resource = entry.resource;
    const sourceType = entry.sourceType;
    let attachments = [];

    if (sourceType === "DocumentReference") {
        attachments = resource.content?.map((c) => c.attachment) || [];
    } else if (sourceType === "DiagnosticReport") {
        attachments = resource.presentedForm || [];
    } else if (sourceType === "Observation" || sourceType === "Media") {
        attachments = Array.isArray(resource.content)
            ? resource.content
            : resource.content
                ? [resource.content]
                : [];
        if (sourceType === "Observation" && resource.valueAttachment) {
            attachments.push(resource.valueAttachment);
        }
    }

    // Normalize each attachment
    return attachments.map((att, idx) => ({
        url: att.url || null,
        data: att.data || null,
        contentType: att.contentType || "application/octet-stream",
        title: att.title || `Attachment ${idx + 1}`,
        creation: att.creation || null
    }));
};

// We'll delegate open/download/preview to AttachmentHandler via ref


const AttachmentPreview = ({ entry, fhirClient }) => {
    const attachmentHandlerRef = useRef(null);

    if (!entry) return <p>Select a document to preview.</p>;

    const attachments = normalizeAttachments(entry);

    // No local modal — AttachmentHandler manages the preview modal

    return (
        <div className={styles.previewContainer}>
            <h6 className={styles.documentHeader}>
                Attachments for Resource ID: {entry.resource.id}
            </h6>

            {attachments.length > 0 ? (
                <div className="list-group mb-2">
                    {attachments.map((att, idx) => (
                        <div key={idx} className={`list-group-item d-flex flex-column ${styles.attachmentItem}`}>
                            <div className={styles.attachmentRow}>
                                {getIconForContentType(att.contentType, "Preview")}
                                <span className={styles.title}>{att.title}</span>
                            </div>

                            {att.creation && (
                                <div className={styles.creation}>
                                    Created: {new Date(att.creation).toLocaleString()}
                                </div>
                            )}

                                    <div className={styles.linkRow}>
                                        <button
                                            className={styles.downloadLink}
                                            onClick={() => attachmentHandlerRef.current?.download(att)}
                                        >
                                            Download
                                        </button>

                                        <button
                                            className={styles.openLink}
                                            onClick={() => attachmentHandlerRef.current?.open(att)}
                                        >
                                            Open
                                        </button>
                                    </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p>No attachments found.</p>
            )}

            {/* Preview modal is handled by AttachmentHandler */}

            {/* AttachmentHandler (hidden) */}
            <AttachmentHandler ref={attachmentHandlerRef} attachments={attachments} fhirClient={fhirClient} showList={false} />
        </div>
    );
};

export default AttachmentPreview;
